import React, { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
type ParallaxImageProps = {
  src: string;
  alt: string;
  className?: string;
  loading?: "eager" | "lazy";
};
export function ParallaxImage({
  src,
  alt,
  className = "",
  loading = "lazy"
}: ParallaxImageProps) {
  const ref = useRef<HTMLDivElement>(null);
  const reduceMotion = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  const y = useTransform(scrollYProgress, [0, 1], reduceMotion ? ["0%", "0%"] : ["-2.5%", "2.5%"]);
  return <div ref={ref} className="absolute inset-0 overflow-hidden" data-id="element-248" data-mp="16sa68e5ycbbk">
      <motion.img src={src} alt={alt} loading={loading} className={`absolute -inset-y-[3%] h-[106%] w-full object-cover ${className}`} style={{
      y
    }} data-id="element-249" data-mp="11tyyc8z7wavz" />
    </div>;
}